import { useAuth } from "@/context/AuthContext";
import { planAllows, PLAN_META, FEATURE_MIN_PLAN } from "@/lib/format";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Btn } from "./ui";

export default function PlanGate({ feature, children }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const plan = user?.business?.plan || "free";
  if (planAllows(plan, feature)) return children;
  const need = PLAN_META[FEATURE_MIN_PLAN[feature]].name;
  return (
    <div className="amden-card p-12 text-center max-w-lg mx-auto mt-6" data-testid="plan-gate">
      <div className="mx-auto grid place-items-center h-14 w-14 rounded-2xl bg-blue-50 text-blue-accent"><Lock size={26} /></div>
      <h3 className="mt-4 text-xl font-bold text-navy">Upgrade to unlock this</h3>
      <p className="mt-2 text-slate-500">This feature is part of the <span className="font-semibold text-navy">{need}</span> plan. Upgrade your workspace to start using it.</p>
      <Btn variant="accent" className="mt-6" onClick={() => nav("/app/settings")} data-testid="plan-gate-upgrade">Upgrade plan</Btn>
    </div>
  );
}
